export default "__VITE_ASSET__5b377923__"